<template>
  <v-navigation-drawer
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    v-model="_drawer"
    fixed
    floating
    class="dashboard-nav-drawer"
    width="270"
    dark
    :style="style"
  >
    <v-list>
      <template v-for="(navItem, index) in navigationItems">
        <v-list-item
          v-if="isVisible(navItem)"
          :to="{ path: navItem.url }"
          :key="index"
          active-class="active-navigation"
        >
          <v-list-item-icon>
            <v-icon>{{ navItem.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="nav-title">
              {{ navItem.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import Config from '@/modules/config/models/Config'

export default {
  name: 'DashboardNavigation',
  props: {
    navigationItems: {
      type: Array,
      required: true
    },
    background: {
      type: String,
      default: null
    },
    drawer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      if (this.background) {
        return {
          'background-image': `url(${this.background})`
        }
      }
      return {}
    },
    _drawer: {
      get() {
        return this.drawer
      },
      set(value) {
        this.$emit('update:drawer', value)
      }
    }
  },
  methods: {
    isVisible(navItem) {
      let hasFilter = navItem.clientFilter
      if (!hasFilter) return true
      return hasFilter.includes(Config.value('title'))
    }
  }
}
</script>

<style lang="scss">
.dashboard-nav-drawer {
  border-right: 1px solid #f1f1f1;
  box-shadow: 1px 0 0 rgba(0, 0, 0, 0.08);
  background-size: cover;
  background-repeat: no-repeat;
  background-color: var(--v-third-base) !important;
  background-position: center bottom;

  .v-list .active-navigation {
    color: var(--v-secondary-base);
    &:before {
      background: transparent;
    }
  }

  > .v-list {
    background: transparent;
  }

  .nav-title {
    font-size: 0.875rem;
  }
}
</style>
